import React, { useEffect, useState } from 'react';
import '../../assets/css/checkout.css';
import Checkout_Left_Block from '../../components/common/Checkout-Page/Checkout-Left-Block';
import Checkout_Right_block from '../../components/common/Checkout-Page/Checkout-Right-block';
import { apiHandler } from '../../api';
import { endpoint } from '../../api/endpoint';
import { GENERATE_HASH } from "../../assets/graphql";
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

const Checkout = () => {
    const [showCheckoutform, setShowcheckOutform] = useState(false);
    const [paymentData, setPaymentData] = useState({});
    const { token } = useSelector((state) => state.login);
    const dispatch = useDispatch();
    const showCheckOut = async (data) => {
    //    console.log(data, "finalData")
        setPaymentData(data);
        setShowcheckOutform(true);
    }
    return (

        <>
            <section className="custombreadcrumb">
                <div className="container">
                    <ul className="breadcrumb justify-content-start">
                        <li className="breadcrumb-item"><a href="/#/home">Home</a></li>
                        <li className="breadcrumb-item active" >Checkout</li>
                    </ul>
                </div>
            </section>

            <section className="cart_wrap checkoutpage">

                <div className="container">

                    <div className="row">
                        <div className="col-xl-9 mx-auto text-center pt-2 pb-4">
                            <div className="mainsection-title">
                                <h2>Checkout</h2>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-8">
                            <Checkout_Left_Block setPaymentData={showCheckOut} />
                        </div>
                        <div className="col-lg-4">
                            <Checkout_Right_block showCheckoutform={showCheckoutform} hideCheckoutform={() => setShowcheckOutform(false)} paymentData={paymentData} />
                        </div>
                    </div>
                </div>

            </section>
        </>
    )
}

export default Checkout;